module.exports = __webpack_public_path__ + "img/technology-split-image-01.4e1f6bb3.svg";